export interface Client {
  id: string;
  name: string;
  comment?: string;
  enableDigitalSignature: boolean;
  modules: string[];
  logoUrl?: string;
  base64EncodedLogoContent?: string;
}
